import styled, { css } from 'styled-components';
import { em } from 'polished';
import { Link } from 'react-router-dom';
import { colors, accessibilityHoverInvert } from 'core/theme';
import { media } from 'core/layout';

export const StyledList = styled.ul`
    border-top: 8px solid ${colors.primaryDark};
    list-style: none;
    margin-top: 0.5em;
    margin-bottom: 0;
    padding-left: 0;
    padding-top: 0.5em;

    ${media.tabletSmall`
      font-size: ${20/24}rem;
      margin-top: 4em;
    `};
`;

export const ListHeading = styled.p`
    font-size: ${em(20)};
    font-weight: 500;
    color: ${colors.text};

    margin-top: 0.7em;
    margin-bottom: 0.2em;

    &:first-child {
        margin-top: 0.35em;
    }
`;

export const StyledLink = styled(Link)`
    font-size: 1em;
    color: ${colors.primary};
    display: inline-block;
    margin: 0.2em 0;
    padding: 0.2em;
    transform: translateX(-0.2em);

    &:hover {
        color: ${colors.primaryLight};
    }
    ${accessibilityHoverInvert};

    ${media.tabletSmall`
      font-size: 1.125em;
    `};
`;



// WEBPACK FOOTER //
// ./src/pages/Raksts/components/SaistitieRaksti/styled.js